import React from "react"
import { Box, Tooltip, TooltipProps } from "@mui/material"

type Props = {
  tooltip?: React.ReactNode
  showTooltip?: boolean
  disabled?: boolean
  tooltipProps?: Omit<TooltipProps, "children" | "title">
  children: React.ReactElement
}

const WithTooltip: React.FC<Props> = ({
  children,
  tooltip,
  showTooltip = false,
  disabled = false,
  tooltipProps = {}
}) => {
  if (!tooltip) return <>{children}</>

  if (showTooltip) {
    return (
      <Tooltip {...tooltipProps} title={tooltip}>
        {disabled ? <Box>{children}</Box> : children}
      </Tooltip>
    )
  }

  return <>{children}</>
}

export default WithTooltip
